import { useState } from "react";
import { useChat } from "../../../contexts/ChatProvider";


const RadioInput = ({options, answers, onSendMessage, theme, isRequired, question}) => {
    const { setIsInputDisabled } = useChat();
    const [selected, setSelected] = useState("");
    const [isQuestionSkipped, setIsQuestionSkipped] = useState(false);

    return (
        <div style={{height: "auto", marginLeft: "12px", marginBottom: "10px", fontSize: "12px"}}>
            {options.map(option => {
                return (
                    <div style={{ marginTop: ""}} key={option}>
                        <input
                            disabled={answers || selected || isQuestionSkipped}
                            id={option}
                            type="radio"
                            name={question+"question-option"}
                            value={option}
                            checked={selected === option || answers?.includes(String(option))}
                            onChange={(e) => {setSelected(e.target.value); onSendMessage(e.target.value); setIsInputDisabled(false);}}
                        />
                        <label for={option} style={{ position: "relative",left: 3, bottom: 3, zIndex: "99" }}> {option}</label>
                    </div>
                )
            })}
            <div style={{width: "100%"}}>
                {!isRequired && !answers && !isQuestionSkipped && !selected && (
                    <div style={{paddingRight: "5px", position: "relative", width: "100%", height: 40, marginBottom: 10}}> 
                        <button
                        color={theme}
                        //disabled={isSubmitted}
                        style={{
                            border: "1px solid ",
                            borderRadius: "10%",
                            position: "absolute",
                            right: 10,
                            bottom: 2,
                            padding: "0 5px",
                            color: "white",
                            backgroundColor: theme,
                            height: 32,
                            fontSize: 12
                        }}
                        onClick={()=> {
                            onSendMessage("skip"); 
                            setIsQuestionSkipped(true); 
                            setIsInputDisabled(false);
                            setSelected("");
                        }}
                        > 
                            Skip
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
export default RadioInput;